// Which trip a screen is about. Pure so it can be tested; the React shell is in
// useResolvedTrip.tsx.

export interface TripOption {
  id: string
  name: string
}

export type TripResolution =
  | { kind: 'ready'; tripId: string }
  | { kind: 'none' }
  | { kind: 'choose'; trips: TripOption[] }

export interface TripDecisionInput {
  paramTrip: string | null
  membershipTripIds: string[]
  /** Only consulted when a choice has to be offered. */
  names?: ReadonlyMap<string, string>
}

export function decideTrip(input: TripDecisionInput): TripResolution {
  // An explicit ?trip= is trusted even for a non-member: RLS refuses the data, and a
  // second check here could only disagree with the real one.
  if (input.paramTrip) return { kind: 'ready', tripId: input.paramTrip }

  const ids = [...new Set(input.membershipTripIds)]
  if (ids.length === 0) return { kind: 'none' }

  const only = ids[0]
  if (ids.length === 1 && only) return { kind: 'ready', tripId: only }

  return {
    kind: 'choose',
    // Fall back to the id so a trip whose name failed to load is still pickable.
    trips: ids.map((id) => ({ id, name: input.names?.get(id) ?? id })),
  }
}
